import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { getEntity, updateEntity, createEntity, reset } from './auth-user-import.reducer';
import { IAuthUserImport } from 'app/shared/model/auth-user-import.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface IAuthUserImportUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const AuthUserImportUpdate = (props: IAuthUserImportUpdateProps) => {
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { authUserImportEntity, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/auth-user-import');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...authUserImportEntity,
        ...values,
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="examsysApp.authUserImport.home.createOrEditLabel">
            <Translate contentKey="examsysApp.authUserImport.home.createOrEditLabel">Create or edit a AuthUserImport</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : authUserImportEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="auth-user-import-id">
                    <Translate contentKey="global.field.id">ID</Translate>
                  </Label>
                  <AvInput id="auth-user-import-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="telLabel" for="auth-user-import-tel">
                  <Translate contentKey="examsysApp.authUserImport.tel">Tel</Translate>
                </Label>
                <AvField id="auth-user-import-tel" type="text" name="tel" />
              </AvGroup>
              <AvGroup>
                <Label id="createDateLabel" for="auth-user-import-createDate">
                  <Translate contentKey="examsysApp.authUserImport.createDate">Create Date</Translate>
                </Label>
                <AvField id="auth-user-import-createDate" type="date" className="form-control" name="createDate" />
              </AvGroup>
              <AvGroup>
                <Label id="startDateLabel" for="auth-user-import-startDate">
                  <Translate contentKey="examsysApp.authUserImport.startDate">Start Date</Translate>
                </Label>
                <AvField id="auth-user-import-startDate" type="date" className="form-control" name="startDate" />
              </AvGroup>
              <AvGroup>
                <Label id="endDateLabel" for="auth-user-import-endDate">
                  <Translate contentKey="examsysApp.authUserImport.endDate">End Date</Translate>
                </Label>
                <AvField id="auth-user-import-endDate" type="date" className="form-control" name="endDate" />
              </AvGroup>
              <AvGroup>
                <Label id="codeLabel" for="auth-user-import-code">
                  <Translate contentKey="examsysApp.authUserImport.code">Code</Translate>
                </Label>
                <AvField id="auth-user-import-code" type="text" name="code" />
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/auth-user-import" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  authUserImportEntity: storeState.authUserImport.entity,
  loading: storeState.authUserImport.loading,
  updating: storeState.authUserImport.updating,
  updateSuccess: storeState.authUserImport.updateSuccess,
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AuthUserImportUpdate);
